import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    alignItems: 'flex-start',
  },
  label: {
    marginTop: 6,
  },
  subLabel: {
    fontSize: pxToEm(12, 14),
    color: theme.palette.grey[700],
  },
});

const SwitchField = ({
  className,
  classes,
  id,
  input,
  label,
  subLabel,
}) => (
  <FormControlLabel
    className={classNames(classes.root, className)}
    control={
      <Switch
        name={input.name}
        checked={input.value || false}
        onChange={input.onChange}
        inputProps={{
          id,
        }}
      />
    }
    label={(
      <div className={classes.label}>
        <div>{label}</div>
        {(subLabel && subLabel.length > 0) &&
          <div className={classes.subLabel}>{subLabel}</div>
        }
      </div>
    )}
  />
);

SwitchField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  subLabel: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string.isRequired,
  }).isRequired,
};

SwitchField.defaultProps = {
  label: '',
  subLabel: '',
  className: '',
};

export default withStyles(styles)(SwitchField);



// WEBPACK FOOTER //
// ./src/components/fields/SwitchField.js